<template>
    <rkm-tabs
        v-model="tabIndex"
        :tab-refs="tabRefs"
    >
        <rkm-tab
            active
            title="Pendentes"
        >
            <Pendente
                ref="Pendente"
            />
        </rkm-tab>

        <rkm-tab title="Permissões">
            <Permissao
                ref="Permissao"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
// Components.
import Pendente from './components/pendente/List'
import Permissao from './components/permissao/List'

export default {
    components: { Pendente, Permissao },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
        save() {

        }
    },
    mounted() {

        this.tabRefs = [
            this.$refs.Pendente,
            this.$refs.Permissao,
        ]
    }
}
</script>